import { store } from 'duck/store'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider as StoreProvider } from 'react-redux'
import { checkForShadowCorporate } from 'services/shadowing'
import { isProductionEnvironment } from 'utils-next/env'

import { App } from './App.component'
import * as serviceWorker from './serviceWorker'

function renderApp(AppComponent: React.ComponentType<any>) {
  checkForShadowCorporate()
  ReactDOM.render(
    <StoreProvider store={store}>
      <AppComponent />
    </StoreProvider>,
    document.getElementById('root') as HTMLElement
  )
}

function enableHotModuleReload() {
  if (!isProductionEnvironment() && module.hot) {
    module.hot.accept('./App.component', () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { App } = require('./App.component')
      renderApp(App)
    })
  }
}

renderApp(App)
enableHotModuleReload()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
